
	(function($){

		$(document).ready(function() {

			$(function() {

				$('.dispatch--toggle-content-in-wrapper').on('click', function(e) {

					e.preventDefault() ;

					$(this).closest('.wrapper').find('.toggle-content').toggleClass('d-none');

				});

				$('.dispatch--toggle-view').on('click', function(e) {

					e.preventDefault() ;

					$('body').toggleClass('state--view-data');
					$('body').toggleClass('state--view-image');

				});

			});

		});

	})(jQuery);



